import React, { useId, memo } from 'react';
import classes from './Checkbox.module.scss';

interface CheckboxProps {
    name?: string;
    label: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
}

const Checkbox = ({ label, checked = false, onChange, name }: CheckboxProps) => {
    const id = useId();

    return (
        <div className={classes.container}>
            <input
                name={name}
                className={classes.input}
                type="checkbox"
                id={id}
                checked={checked}
                onChange={(e) => onChange?.(e.target.checked)}
            />
            <label className={classes.label} htmlFor={id}>
                {label}
            </label>
        </div>
    );
};

export default memo(Checkbox);
